// Hook pour gérer les templates de documents génériques
export const useDocumentTemplates = () => {
  const genericDocumentTypes = [
    {
      id: 'LIVRET_ACCUEIL',
      label: 'Livret d\'Accueil',
      description: 'Document d\'information et d\'accueil pour les bénéficiaires',
      template: `<!-- 1. Édito / mot de bienvenue -->
    <section id="edito">
      <div class="card">
        <h2>Bienvenue</h2>
        <p>Nous sommes heureux de vous accueillir parmi nos bénéficiaires. Ce livret a pour objectif de vous présenter notre structure, nos services et les modalités de notre collaboration.</p>
      </div>
    </section>

    <!-- 2. Présentation de la structure -->
    <section id="presentation">
      <div class="card">
        <h2>Notre Structure</h2>
        <p>Notre organisation est spécialisée dans l'accompagnement à domicile et s'engage à vous offrir des services de qualité adaptés à vos besoins.</p>
      </div>
    </section>

    <!-- 3. Nos valeurs -->
    <section id="valeurs">
      <div class="card">
        <h2>Nos Valeurs</h2>
        <ul>
          <li><strong>Respect</strong> : De la personne, de son intimité et de ses choix</li>
          <li><strong>Écoute</strong> : Adaptation à vos besoins spécifiques</li>
          <li><strong>Professionnalisme</strong> : Compétence et sérieux dans nos interventions</li>
          <li><strong>Bienveillance</strong> : Accompagnement personnalisé et attentionné</li>
        </ul>
      </div>
    </section>

    <!-- 4. Nos services -->
    <section id="services">
      <div class="card">
        <h2>Nos Services</h2>
        <ul>
          <li>Aide à la toilette et à l'habillage</li>
          <li>Aide aux repas</li>
          <li>Accompagnement dans les déplacements</li>
          <li>Aide aux courses et à la préparation des repas</li>
          <li>Entretien du logement</li>
          <li>Soutien administratif</li>
        </ul>
      </div>
    </section>

    <!-- 5. Vos interlocuteurs -->
    <section id="interlocuteurs">
      <div class="card">
        <h2>Vos Interlocuteurs</h2>
        <p><strong>Responsable de secteur :</strong> Votre interlocuteur privilégié pour toute question concernant votre prise en charge.</p>
        <p><strong>Intervenants :</strong> Des professionnels formés et qualifiés qui vous accompagnent au quotidien.</p>
      </div>
    </section>

    <!-- 6. Horaires et disponibilités -->
    <section id="horaires">
      <div class="card">
        <h2>Horaires et Disponibilités</h2>
        <p>Nos services sont disponibles du lundi au vendredi de 7h à 20h, et le samedi de 8h à 18h.</p>
        <p>Pour les urgences en dehors de ces horaires, un numéro de permanence est à votre disposition.</p>
      </div>
    </section>

    <!-- 7. Sécurité et confidentialité -->
    <section id="securite">
      <div class="card">
        <h2>Sécurité et Confidentialité</h2>
        <p>Tous nos intervenants sont soumis au secret professionnel. Vos informations personnelles sont traitées avec la plus grande confidentialité.</p>
      </div>
    </section>`
    },
    {
      id: 'CHARTE_DROITS',
      label: 'Charte des Droits et Libertés',
      description: 'Droits fondamentaux des bénéficiaires',
      template: `<!-- 1. Préambule -->
    <section id="preambule">
      <div class="card">
        <h2>Préambule</h2>
        <p>Notre organisation s'engage à respecter et à faire respecter les droits fondamentaux de chaque personne accompagnée. Cette charte définit les principes essentiels qui guident notre action au quotidien.</p>
      </div>
    </section>

    <!-- 2. Droits fondamentaux -->
    <section id="droits-fondamentaux">
      <div class="card">
        <h2>Droits Fondamentaux</h2>
        
        <div class="callout">
          <strong>Article 1 - Droit à la dignité</strong>
          <p>Toute personne a droit au respect de sa dignité, de son intégrité, de sa vie privée, de son intimité et de sa sécurité.</p>
        </div>

        <div class="callout">
          <strong>Article 2 - Droit à l'autonomie</strong>
          <p>Chaque personne a le droit de conserver son autonomie, de faire ses propres choix et de participer aux décisions qui la concernent.</p>
        </div>

        <div class="callout">
          <strong>Article 3 - Droit à l'information</strong>
          <p>Toute personne a le droit d'être informée sur son état de santé, les soins proposés, les intervenants et les modalités de prise en charge.</p>
        </div>

        <div class="callout">
          <strong>Article 4 - Droit au consentement</strong>
          <p>Aucune intervention ne peut être pratiquée sans le consentement libre et éclairé de la personne, sauf cas d'urgence.</p>
        </div>

        <div class="callout">
          <strong>Article 5 - Droit au refus</strong>
          <p>Chaque personne a le droit de refuser un soin ou une intervention, après en avoir été informée des conséquences.</p>
        </div>

        <div class="callout">
          <strong>Article 6 - Droit à la confidentialité</strong>
          <p>Toutes les informations concernant la personne sont confidentielles et ne peuvent être communiquées qu'avec son accord.</p>
        </div>

        <div class="callout">
          <strong>Article 7 - Droit à la liberté d'expression</strong>
          <p>Chaque personne a le droit d'exprimer ses opinions, ses souhaits et ses préférences.</p>
        </div>

        <div class="callout">
          <strong>Article 8 - Droit à la pratique religieuse</strong>
          <p>La liberté de conscience et de pratique religieuse est respectée.</p>
        </div>

        <div class="callout">
          <strong>Article 9 - Droit aux relations sociales</strong>
          <p>Chaque personne a le droit de recevoir des visites, de communiquer avec ses proches et de maintenir ses relations sociales.</p>
        </div>

        <div class="callout">
          <strong>Article 10 - Droit de réclamation</strong>
          <p>Toute personne a le droit de formuler des réclamations ou des suggestions concernant son accompagnement.</p>
        </div>
      </div>
    </section>

    <!-- 3. Engagement de l'organisation -->
    <section id="engagement">
      <div class="card">
        <h2>Engagement de Notre Organisation</h2>
        <p>Nous nous engageons à :</p>
        <ul>
          <li>Former régulièrement nos intervenants au respect de cette charte</li>
          <li>Mettre en place les moyens nécessaires pour garantir ces droits</li>
          <li>Traiter rapidement toute réclamation ou suggestion</li>
          <li>Respecter scrupuleusement les principes énoncés</li>
        </ul>
      </div>
    </section>`
    },
    {
      id: 'REGLEMENT_INTERIEUR',
      label: 'Règlement Intérieur',
      description: 'Règles de fonctionnement de l\'établissement',
      template: `<!-- 1. Préambule -->
    <section id="preambule">
      <div class="card">
        <h2>Préambule</h2>
        <p>Le présent règlement intérieur a pour objet de définir les règles de fonctionnement de notre organisation afin d'assurer le bon déroulement des interventions et le respect mutuel entre tous les acteurs.</p>
      </div>
    </section>

    <!-- 2. Objet -->
    <section id="objet">
      <div class="card">
        <h2>Article 1 - Objet</h2>
        <p>Ce règlement s'applique à l'ensemble des bénéficiaires, intervenants et visiteurs de notre organisation.</p>
      </div>
    </section>

    <!-- 3. Horaires d'intervention -->
    <section id="horaires">
      <div class="card">
        <h2>Article 2 - Horaires d'intervention</h2>
        <p>Les interventions ont lieu selon les plages horaires convenues dans le contrat de prestation :</p>
        <ul>
          <li>Du lundi au vendredi : 7h00 - 20h00</li>
          <li>Samedi : 8h00 - 18h00</li>
          <li>Dimanche et jours fériés : Interventions exceptionnelles sur demande</li>
        </ul>
        <p>En cas de retard ou d'absence imprévue, le bénéficiaire est prié de prévenir notre organisation au plus tôt.</p>
      </div>
    </section>

    <!-- 4. Comportement et respect -->
    <section id="comportement">
      <div class="card">
        <h2>Article 3 - Comportement et respect</h2>
        <p>Toute personne doit faire preuve de respect envers les autres bénéficiaires, intervenants et membres du personnel.</p>
        <p>Toute forme de discrimination, de violence, d'agression verbale ou physique, de harcèlement moral ou sexuel est strictement interdite.</p>
      </div>
    </section>

    <!-- 5. Sécurité et hygiène -->
    <section id="securite-hygiene">
      <div class="card">
        <h2>Article 4 - Sécurité et hygiène</h2>
        <p>Chacun doit veiller à sa sécurité et à celle des autres. Les règles d'hygiène élémentaires doivent être respectées.</p>
        <p>Il est interdit de fumer dans les locaux et pendant les interventions. La consommation d'alcool est interdite pendant le service.</p>
      </div>
    </section>

    <!-- 6. Confidentialité -->
    <section id="confidentialite">
      <div class="card">
        <h2>Article 5 - Confidentialité</h2>
        <p>Toutes les informations concernant les bénéficiaires, les intervenants et le fonctionnement de notre organisation sont confidentielles.</p>
      </div>
    </section>

    <!-- 7. Utilisation des équipements -->
    <section id="equipements">
      <div class="card">
        <h2>Article 6 - Utilisation des équipements</h2>
        <p>Le matériel et les équipements mis à disposition doivent être utilisés avec soin et selon leur destination.</p>
      </div>
    </section>

    <!-- 8. Réclamations et suggestions -->
    <section id="reclamations">
      <div class="card">
        <h2>Article 7 - Réclamations et suggestions</h2>
        <p>Toute réclamation ou suggestion doit être adressée par écrit au responsable de notre organisation.</p>
      </div>
    </section>

    <!-- 9. Modification du règlement -->
    <section id="modification">
      <div class="card">
        <h2>Article 8 - Modification du règlement</h2>
        <p>Notre organisation se réserve le droit de modifier le présent règlement. Les modifications seront portées à la connaissance des intéressés.</p>
      </div>
    </section>`
    },
    {
      id: 'CGS',
      label: 'Conditions Générales de Service',
      description: 'Règles générales régissant les services',
      template: `<!-- 1. Objet -->
    <section id="objet">
      <div class="card">
        <h2>Article 1 - Objet</h2>
        <p>Les présentes conditions générales ont pour objet de définir les modalités de fourniture des services par notre organisation à ses clients.</p>
      </div>
    </section>

    <!-- 2. Définitions -->
    <section id="definitions">
      <div class="card">
        <h2>Article 2 - Définitions</h2>
        <div class="callout">
          <strong>Client</strong>
          <p>Personne physique ou morale bénéficiant des services de notre organisation.</p>
        </div>
        <div class="callout">
          <strong>Service</strong>
          <p>Prestation d'aide à domicile fournie par notre organisation.</p>
        </div>
        <div class="callout">
          <strong>Intervenant</strong>
          <p>Personnel qualifié de notre organisation assurant les prestations.</p>
        </div>
      </div>
    </section>

    <!-- 3. Prestations -->
    <section id="prestations">
      <div class="card">
        <h2>Article 3 - Prestations</h2>
        <p>Notre organisation s'engage à fournir les prestations décrites dans le contrat de service, avec professionnalisme et dans le respect des règles déontologiques.</p>
      </div>
    </section>

    <!-- 4. Tarifs et facturation -->
    <section id="tarifs">
      <div class="card">
        <h2>Article 4 - Tarifs et facturation</h2>
        <p>Les tarifs sont ceux en vigueur à la date de signature du contrat. Toute modification des tarifs sera communiquée avec un préavis de 30 jours.</p>
      </div>
    </section>

    <!-- 5. Responsabilités -->
    <section id="responsabilites">
      <div class="card">
        <h2>Article 5 - Responsabilités</h2>
        <p>Notre organisation décline toute responsabilité en cas de dommages résultant du non-respect par le client des consignes de sécurité.</p>
      </div>
    </section>

    <!-- 6. Confidentialité -->
    <section id="confidentialite">
      <div class="card">
        <h2>Article 6 - Confidentialité</h2>
        <p>Notre organisation s'engage à respecter la confidentialité des informations concernant le client.</p>
      </div>
    </section>

    <!-- 7. Résiliation -->
    <section id="resiliation">
      <div class="card">
        <h2>Article 7 - Résiliation</h2>
        <p>Le contrat peut être résilié par l'une ou l'autre des parties avec un préavis de 30 jours.</p>
      </div>
    </section>

    <!-- 8. Litiges -->
    <section id="litiges">
      <div class="card">
        <h2>Article 8 - Litiges</h2>
        <p>En cas de litige, les parties s'efforceront de trouver une solution amiable avant toute action judiciaire.</p>
      </div>
    </section>`
    }
  ];

  return { genericDocumentTypes };
};
